<app-loading-spinner
  *ngIf="!faqDetails?.length else faqSection"
></app-loading-spinner>

<ng-template #faqSection>
  <app-banner
    [image]="image"
    [bannerTitle]="bannerTitle"
    [additionalStyles]="{ height: '21vh' }"
    [bannerTextStyles]="{ left: '7vw', top:'7vw' }"
  ></app-banner>
  <section class="create_new container-fluid content-section">
    <div class="back-icon-row" (click)="onBackClick()">
      <span class="back-icon-container" style="cursor: pointer;">
      <span class="uil-dl-icon-Arrow-left uil-color-primary back-icon"></span>
      <span class="back-icon-text">Back</span>
    </span>
    </div>
    <div class="row faq-body">
      <div class="col-md-8 left-portion">
         <div class="quickTitle">Frequently Asked Questions</div>
         <app-collapse-card [faqData]="faqDetails"></app-collapse-card>
      </div>
      <div class="col-md-3">
        <a href="mailto:IXDevHub.Support@accenture.com?subject=Industry X Developer Hub : Support Request&body=%0D%0A%0D%0A" target="_blank">
        <div class="uil-card-shadow">
          <div
            class="uil-card-span-12 uil-clickable uil-black-card height_adjust uil-card-default marginTop"
          >
          <!-- [routerLink]="['/supportRequest']" -->
            <div class="uil-card-title-area">
              <div class="uil-card-title card-title">
                Still cannot find the answer?
              </div>
            </div>
            <div
              class="uil-card-text uil-dls-font-caption-02 card-description card-label"
            >
              Reach out to the support team.
            </div>
            <div class="uil-card-footer">
              <div class="uil-card-footer-icon-area">
                <div class="uil-icon-Arrow-right-up"></div>
              </div>
            </div>
          </div>
        </div>
        </a>
  
        <div class="uil-card-shadow">
          <div
            class="uil-card-span-12 uil-clickable uil-black-card height_adjust uil-card-default uilCard"
          >
          <a href='mailto:IXDevHub.Support@accenture.com?subject=Industry X Developer Hub : Feedback&body=Hi Industry X Developer Hub Team,%0D%0A%0D%0AFollowing is the feedback I would like to share:%0D%0A< Insert feedback here >;' target="_blank">
              <div class="uil-card-title-area">
                <div class="uil-card-title card-title">General Feedback</div>
              </div>
              <div
                class="uil-card-text uil-dls-font-caption-02 card-description card-label"
              >
            Send feedback to support team.</div>
              <div class="uil-card-footer">
                <div class="uil-card-footer-icon-area">
                  <div class="uil-icon-Arrow-right-up"></div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</ng-template>